<template>
  <div class="statistics-box">
    <Row :gutter="24">
      <!--总销售额-->
      <Col span="6" class="pb12">
        <div class="data-content">
          <div class="head">
            <span>{{ $t('key1002888') }}{{ currencyState }})</span>
            <Tooltip placement="top" max-width="450" transfer :content="$t('key1002879')+`${configCharacters()}`+$t('key1002880')">
              <Icon type="ios-alert-outline f-18" class="cursor-pointer"/>
            </Tooltip>
          </div>
          <div class="account">
            <span class="currency">￥</span>
            <span class="price">{{ operatingData.rptYmsPackageSalesTotalBo.totalSalesVolume }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002889') }}</span>
            <span class="price">{{ '￥' + operatingData.rptYmsPackageSalesTotalBo.monthSalesVolume }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002890') }}</span>
            <span class="price">{{ '￥' + operatingData.rptYmsPackageSalesTotalBo.yesterdaySalesVolume }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002891') }}</span>
            <span class="price">{{ '￥' + operatingData.rptYmsPackageSalesTotalBo.todaySalesVolume }}</span>
          </div>
        </div>
      </Col>
      <!--订单总数-->
      <Col span="6" class="pb12">
        <div class="data-content">
          <div class="head">
            <span>{{ $t('key1002892') }}</span>
            <Tooltip placement="top" max-width="450" transfer :content="$t('key1002879')+`${configCharacters()}`+$t('key1002881')">
              <Icon type="ios-alert-outline f-18" class="cursor-pointer"/>
            </Tooltip>
          </div>
          <div class="account">
            <span class="price">{{ operatingData.rptYmsPackageSalesTotalBo.totalOrderQuantity }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002893') }}</span>
            <span class="price">{{ operatingData.rptYmsPackageSalesTotalBo.monthOrderQuantity }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002894') }}</span>
            <span class="price">{{ operatingData.rptYmsPackageSalesTotalBo.yesterdayOrderQuantity }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002895') }}</span>
            <span class="price">{{ operatingData.rptYmsPackageSalesTotalBo.todayOrderQuantity }}</span>
          </div>
        </div>
      </Col>
      <!--在售商品数-->
      <Col span="6" class="pb12">
        <div class="data-content">
          <div class="head">
            <span>{{ $t('key1002896') }}</span>
            <Tooltip placement="top" max-width="450" transfer :content="$t('key1002879')+`${configCharacters()}`+$t('key1002882')">
              <Icon type="ios-alert-outline f-18" class="cursor-pointer"/>
            </Tooltip>
          </div>
          <div class="account">
            <span class="price">{{ skuData.onSaleQuantity }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002897') }}</span>
            <span class="price">{{ skuData.monthShelveSKuQuantity }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002898') }}</span>
            <span class="price">{{ skuData.yesterdayShelveSKuQuantity }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002899') }}</span>
            <span class="price">{{ skuData.todayShelveSKuQuantity }}</span>
          </div>
        </div>
      </Col>
      <!--商品订阅数-->
      <Col span="6" class="pb12">
        <div class="data-content">
          <div class="head">
            <span>{{ $t('key1002900') }}</span>
            <Tooltip class="reset_tooltip_style" placement="top-end" max-width="500" transfer
              :content="$t('key1002883')">
              <Icon type="ios-alert-outline f-18" class="cursor-pointer"/>
            </Tooltip>
          </div>
          <div class="account">
            <span class="price">{{ skuData.subscribeSpuQuantity }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002901') }}</span>
            <span class="price">{{ skuData.monthSubscribeSpuQuantity }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002902') }}</span>
            <span class="price">{{ skuData.yesterdaySubscribeSpuQuantity }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002903') }}</span>
            <span class="price">{{ skuData.todaySubscribeSpuQuantity }}</span>
          </div>
        </div>
      </Col>
      <!--上架商品数-->
      <Col span="6" class="pt12">
        <div class="data-content">
          <div class="head">
            <span>{{ $t('key1002904') }}</span>
            <Tooltip placement="top" max-width="450" transfer :content="$t('key1002884')">
              <Icon type="ios-alert-outline f-18" class="cursor-pointer"/>
            </Tooltip>
          </div>
          <div class="account">
            <span class="price">{{ skuData.shelfQuantity }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002905') }}</span>
            <span class="price">{{ skuData.monthShelfQuantity }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002906') }}</span>
            <span class="price">{{ skuData.yesterdayShelfQuantity }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002907') }}</span>
            <span class="price">{{ skuData.todayShelfQuantity }}</span>
          </div>
        </div>
      </Col>
      <!--发布刊登数-->
      <Col span="6" class="pt12">
        <div class="data-content">
          <div class="head">
            <span>{{ $t('key1002908') }}</span>
            <Tooltip placement="top" max-width="450" transfer :content="$t('key1002885')">
              <Icon type="ios-alert-outline f-18" class="cursor-pointer"/>
            </Tooltip>
          </div>
          <div class="account">
            <span class="price">{{ skuData.publishQuantity }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002909') }}</span>
            <span class="price">{{ skuData.monthPublishQuantity }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002910') }}</span>
            <span class="price">{{ skuData.yesterdayPublishQuantity }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002911') }}</span>
            <span class="price">{{ skuData.todayPublishQuantity }}</span>
          </div>
        </div>
      </Col>
      <!--供应商总数-->
      <Col span="6" class="pt12">
        <div class="data-content">
          <div class="head">
            <span>{{ $t('key1002912') }}</span>
          </div>
          <div class="account">
            <span class="price">{{ operatingData.ymsMerchantStatisticsResult.supplierCount }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002913') }}</span>
            <span class="price">{{ operatingData.ymsMerchantStatisticsResult.supplierMonthCount }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002914') }}</span>
            <span class="price">{{ operatingData.ymsMerchantStatisticsResult.supplierYesterdayCount }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002915') }}</span>
            <span class="price">{{ operatingData.ymsMerchantStatisticsResult.supplierTodayCount }}</span>
          </div>
        </div>
      </Col>
      <!--分销商总数-->
      <Col span="6" class="pt12">
        <div class="data-content">
          <div class="head">
            <span>{{ $t('key1002916') }}</span>
          </div>
          <div class="account">
            <span class="price">{{ operatingData.ymsMerchantStatisticsResult.distributorCount }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002913') }}</span>
            <span class="price">{{ operatingData.ymsMerchantStatisticsResult.distributorMonthCount }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002914') }}</span>
            <span class="price">{{ operatingData.ymsMerchantStatisticsResult.distributorYesterdayCount }}</span>
          </div>
          <div class="relevant">
            <span class="mr5">{{ $t('key1002915') }} </span>
            <span class="price">{{ operatingData.ymsMerchantStatisticsResult.distributorTodayCount }}</span>
          </div>
        </div>
      </Col>
    </Row>
    <!--订单状态-->
    <Row :gutter="24" class="mt24">
      <Col span="24">
        <Card :bordered="false" dis-hover class="card-box">
          <template #title>
            <h2 class="line-header">{{ $t('key1002917') }}</h2>
          </template>
          <Row type="flex" justify="space-around">
            <Col span="4" class="text-center">
              <p class="sub-title">{{ $t('key1002918') }}</p>
              <p class="sub-quantity">{{ operatingData.ymsPackageStatusStatisticsBos.pendingQuantity }}</p>
            </Col>
            <Col span="4" class="text-center">
              <p class="sub-title">{{ $t('key1001808') }}</p>
              <p class="sub-quantity">{{ operatingData.ymsPackageStatusStatisticsBos.pickedQuantity }}</p>
            </Col>
            <Col span="4" class="text-center">
              <p class="sub-title">{{ $t('key1002919') }}</p>
              <p class="sub-quantity">{{ operatingData.ymsPackageStatusStatisticsBos.changeQuantity }}</p>
            </Col>
            <Col span="4" class="text-center">
              <p class="sub-title">{{ $t('key1001810') }}</p>
              <p class="sub-quantity">{{ operatingData.ymsPackageStatusStatisticsBos.packedQuantity }}</p>
            </Col>
            <Col span="4" class="text-center">
              <p class="sub-title">{{ $t('key1002920') }}</p>
              <p class="sub-quantity">{{ operatingData.ymsPackageStatusStatisticsBos.shippedQuantity }}</p>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
    <!--销量、排名-->
    <Row :gutter="24" class="mt24">
      <Col span="12">
        <div class="footer-box">
          <Tabs v-model="tabValue" @on-click="changeDate(value2)">
            <TabPane :label="$t('key1002871')" name="0"></TabPane>
            <TabPane :label="$t('key1002872')" name="1"></TabPane>
            <template #extra>
              <div style="margin-top: 12px;margin-right:10px;">
                <span class="ml10 cursor-pointer" :class="{activeColor:dataType === 0}" @click="setDate(0)">{{ $t('key1002921') }}</span>
                <span class="ml10 cursor-pointer" :class="{activeColor:dataType === 1}" @click="setDate(1)">{{ $t('key1002922') }}</span>
                <span class="ml10 cursor-pointer" :class="{activeColor:dataType === 2}" @click="setDate(2)">{{ $t('key1002923') }}</span>
                <DatePicker v-model="value2" format="yyyy-MM-dd" transfer type="daterange" :clearable="false"
                  :options="options"
                  @on-change="changeDate"
                  placement="bottom-end" class="ml10" :placeholder="$t('key1002289')" style="width: 200px"></DatePicker>
              </div>
            </template>
          </Tabs>
          <div class="s-card-content" type="flex">
            <div id="main" style="width:100%;height:400px;"></div>
          </div>
        </div>
      </Col>
      <Col span="12">
        <div class="footer-box">
          <Tabs v-model="orderTabsValue" @on-click="changeRankType">
            <TabPane :label="$t('key1002886')" name="0"></TabPane>
            <TabPane :label="$t('key1002887')" name="1"></TabPane>
            <template #extra>
              <div style="margin-top: 12px;margin-right:20px;line-height: 38px;">
                <span class="ml10 cursor-pointer" :class="{activeColor: rankType === 0}" @click="rankType = 0;changeRankType();">{{ $t('key1002921') }}</span>
                <span class="ml10 cursor-pointer" :class="{activeColor: rankType === 1}" @click="rankType = 1;changeRankType();">{{ $t('key1002922') }}</span>
              </div>
            </template>
          </Tabs>
          <div class="s-card-content p20" style="padding-top: 0;">
            <Table highlight-row max-height="380" :columns="rankingColumns" :data="rankingData"></Table>
          </div>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {amountHandel} from '@/utils/common';

var myCharts;
export default {
  name: 'statistics',
  mixins: [Mixin],
  data() {
    return {
      value2: [],
      dataType: 0,
      tabValue: '0',
      rankType: 0,
      orderTabsValue: '0',
      rankingData: [],
      rankingDataOrigin: null,
      options: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now();
        }
      },
      data1: [
        {
          name: '12'
        }
      ],
      operatingData: {
        "rptYmsPackageSalesTotalBo": {
          "monthOrderQuantity": 0, // 本月订单量
          "monthSalesVolume": 0, // 本月销售额
          "todayOrderQuantity": 0, // 今日订单量
          "todaySalesVolume": 0, // 今日销售额
          "totalOrderQuantity": 0, // 总订单量
          "totalSalesVolume": 0, // 总销售额
          "yesterdayOrderQuantity": 0, // 昨日订单量
          "yesterdaySalesVolume": 0 // 昨日销售额
        },
        "ymsMerchantStatisticsResult": {
          "distributorCount": 0, // 分销商总数
          "distributorMonthCount": 0, // 分销商本月新增
          "distributorTodayCount": 0, // 分销商今日新增
          "distributorYesterdayCount": 0, //  分销商昨日新增
          "supplierCount": 0, // 供应商总数
          "supplierMonthCount": 0, // 供应商本月新增
          "supplierTodayCount": 0, // 供应商今日新增
          "supplierYesterdayCount": 0 // 供应商昨日新增
        },
        "ymsPackageStatusStatisticsBos": {
          "changeQuantity": 0, // 待换单
          "packedQuantity": 0, // 待装箱
          "pendingQuantity": 0, // 待下单
          "pickedQuantity": 0, // 待拣货
          "shippedQuantity": 0 // 待发货
        }
      },
      merchantArr: [],
      skuData: {
        "monthPublishQuantity": 0,   // 本月刊登数量
        "monthShelfQuantity": 0, // 本月上架数量
        "monthShelveSKuQuantity": 0, // 本月上新数量
        "monthSubscribeSpuQuantity": 0, // 本月订阅数量
        "onSaleQuantity": 0, // 在售数量
        "publishQuantity": 0, // 刊登数量
        "shelfQuantity": 0, // 上架数量
        "subscribeSpuQuantity": 0, // 订阅数量
        "todayPublishQuantity": 0, // 今日刊登数量
        "todayShelfQuantity": 0, // 今日上架数量
        "todayShelveSKuQuantity": 0, //  今日上新数量
        "todaySubscribeSpuQuantity": 0, // 今日订阅数量
        "yesterdayPublishQuantity": 0, // 昨日刊登数量
        "yesterdayShelfQuantity": 0, //  昨日上架数量
        "yesterdayShelveSKuQuantity": 0, // 昨日上新数量
        "yesterdaySubscribeSpuQuantity": 0, //  昨日订阅数量

      }
    };
  },
  created() {
    this.setDate(0);
    this.getBulletinBoardData();
    this.getQueryOrderRanking();
    this.getSkuQuantity();
  },
  mounted() {

  },
  methods: {
    changeRankType() {
      if (this.orderTabsValue === '0') {
        // 供应商订单排名
        if (this.rankType === 0) {
          this.rankingData = this.rankingDataOrigin.ymsPackageSupplierSalesWeeks;
        } else {
          this.rankingData = this.rankingDataOrigin.ymsPackageSupplierSalesMonths;
        }
      } else if (this.orderTabsValue === '1') {
        // 分销商订单排名
        if (this.rankType === 0) {
          this.rankingData = this.rankingDataOrigin.ymsPackageDistributorSalesWeeks;
        } else {
          this.rankingData = this.rankingDataOrigin.ymsPackageDistributorSalesMonths;
        }
      }
    },
    setChart(type, xAxis, seriesData) {
      // 指定图表的配置项和数据
      var option = {
        tooltip: {},
        xAxis: {
          data: xAxis
        },
        barMaxWidth: 60,//最大宽度
        yAxis: {},
        series: [
          {
            name: type === '0' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002871') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002872'),
            type: 'bar',
            data: seriesData
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      if (myCharts != null && myCharts != "" && myCharts != undefined) {
        myCharts.dispose();
      }
      myCharts = this.$echarts.init(document.getElementById('main'), null, {
        width: 'auto',
        height: '400px',
      });
      myCharts.setOption(option);
      setTimeout(() => {
        myCharts.resize();
      }, 200);
    },
    // 获取数据看板数据
    getBulletinBoardData() {
      let v = this;
      v.axios.get(api.get_ymsCoreCommon_index).then((response) => {
        if (response.data.code === 0) {
          let rptYmsPackageSalesTotalBo = Object.assign({}, v.operatingData.rptYmsPackageSalesTotalBo, response.data.datas.rptYmsPackageSalesTotalBo);
          let ymsMerchantStatisticsResult = Object.assign({}, v.operatingData.rptYmsPackageSalesTotalBo, response.data.datas.ymsMerchantStatisticsResult);
          let ymsPackageStatusStatisticsBos = Object.assign({}, v.operatingData.rptYmsPackageSalesTotalBo, response.data.datas.ymsPackageStatusStatisticsBos);
          for (let key in rptYmsPackageSalesTotalBo) {
            if (rptYmsPackageSalesTotalBo[key]) {
              const toFix = ['totalSalesVolume', 'yesterdaySalesVolume', 'todaySalesVolume'];
              if (toFix.includes(key)) {
                rptYmsPackageSalesTotalBo[key] = amountHandel(rptYmsPackageSalesTotalBo[key]);
              }
              rptYmsPackageSalesTotalBo[key] = v.priceTransform(rptYmsPackageSalesTotalBo[key]);
            } else {
              rptYmsPackageSalesTotalBo[key] = 0;
            }
          }
          for (let key in ymsMerchantStatisticsResult) {
            if (ymsMerchantStatisticsResult[key]) {
              ymsMerchantStatisticsResult[key] = v.priceTransform(ymsMerchantStatisticsResult[key]);
            } else {
              ymsMerchantStatisticsResult[key] = 0;
            }
          }
          for (let key in ymsPackageStatusStatisticsBos) {
            if (ymsPackageStatusStatisticsBos[key]) {
              ymsPackageStatusStatisticsBos[key] = v.priceTransform(ymsPackageStatusStatisticsBos[key]);
            } else {
              ymsPackageStatusStatisticsBos[key] = 0;
            }
          }

          this.operatingData.rptYmsPackageSalesTotalBo = rptYmsPackageSalesTotalBo;
          this.operatingData.ymsMerchantStatisticsResult = ymsMerchantStatisticsResult;
          this.operatingData.ymsPackageStatusStatisticsBos = ymsPackageStatusStatisticsBos;
        }
      });
    },
    getOrderSale(startTime, endTime) {
      let v = this;
      v.axios.post(api.post_ymsCoreCommon, {
        endTime: endTime,
        startTime: startTime,
      }).then((response) => {
        if (response.data.code === 0) {
          let xAxis = [];
          let seriesData = [];
          let days = response.data.datas.rptYmsPackageSalesDays;
          let months = response.data.datas.rptYmsPackageSalesMonths;
          if (days) {
            xAxis = days.map(i => i.shipedTime);
            seriesData = days.map(i => v.tabValue === '0' ? i.totalProductGoodsCost : i.totalOrderQuantity);
            this.setChart(v.tabValue, xAxis, seriesData);
          } else if (months) {
            xAxis = months.map(i => i.shipedTimeMonth + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000493'));
            seriesData = months.map(i => v.tabValue === '0' ? i.totalProductGoodsCost : i.totalOrderQuantity);
            this.setChart(v.tabValue, xAxis, seriesData);
          } else {
            this.setChart(v.tabValue, xAxis, seriesData);
          }
        }
      });
    },
    /**
     *
     * @date: 2022/2/19 11:05
     * @param: type 0 本周 1 本月 2 本年
     *
     */
    setDate(type) {
      let endTme;
      let startTme;
      let now = new Date(); // 当前日期
      const DAYTIME = 24 * 60 * 60 * 1000;
      this.dataType = type;
      if (type === 0) {
        let day = now.getDay() === 0 ? 6 - now.getDay() : now.getDay() - 1;
        endTme = this.$uDate.getCurrentTime(null, day * DAYTIME);
        startTme = this.$uDate.getCurrentTime();

      } else if (type === 1) {
        endTme = this.$uDate.getCurrentTime(null, (now.getDate() - 1) * DAYTIME);
        startTme = this.$uDate.getCurrentTime();
      } else if (type === 2) {
        endTme = this.$uDate.format('yyyy-MM-dd', now.getFullYear() + '-1-1');
        startTme = this.$uDate.getCurrentTime();
      }
      this.value2 = [endTme, startTme];
      this.getOrderSale(endTme, startTme);
    },
    changeDate(data) {
      if ((new Date(data[1]).getTime() - new Date(data[0]).getTime()) > 86400 * 1000 * 365) {
        this.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002873'));
        return;
      }
      this.getOrderSale(data[0], data[1]);
    },
    getAllMerchantIds() {
      let merchantIds = {};
      if (this.rankingDataOrigin.ymsPackageDistributorSalesMonths) {
        this.rankingDataOrigin.ymsPackageDistributorSalesMonths.forEach(i => {
          if (!merchantIds[i.distributorMerchantId]) {
            merchantIds[i.distributorMerchantId] = true;
          }
        });
      }
      if (this.rankingDataOrigin.ymsPackageDistributorSalesWeeks) {
        this.rankingDataOrigin.ymsPackageDistributorSalesWeeks.forEach(i => {
          if (!merchantIds[i.distributorMerchantId]) {
            merchantIds[i.distributorMerchantId] = true;
          }
        });
      }
      if (this.rankingDataOrigin.ymsPackageSupplierSalesMonths) {
        this.rankingDataOrigin.ymsPackageSupplierSalesMonths.forEach(i => {
          if (!merchantIds[i.supplierMerchantId]) {
            merchantIds[i.supplierMerchantId] = true;
          }
        });
      }
      if (this.rankingDataOrigin.ymsPackageSupplierSalesWeeks) {
        this.rankingDataOrigin.ymsPackageSupplierSalesWeeks.forEach(i => {
          if (!merchantIds[i.supplierMerchantId]) {
            merchantIds[i.supplierMerchantId] = true;
          }
        });
      }
      return Object.keys(merchantIds);
    },
    // 获取订单排名
    getQueryOrderRanking() {
      let v = this;
      v.axios.get(api.get_ymsCoreCommon_queryOrderRanking).then((response) => {
        if (response.data.code === 0) {
          this.rankingDataOrigin = response.data.datas;
          this.getMerchant(this.getAllMerchantIds()).then((data) => {
            this.merchantArr = data;
            this.rankingData = this.rankingDataOrigin.ymsPackageSupplierSalesWeeks;
          });
        }
      });
    },
    getMerchant(ids) {
      let v = this;
      return new Promise(resolve => {
        if (ids.length === 0) {
          resolve([]);
          return;
        }
        v.axios.post(api.get_ymsMerchant_queryByIds, ids).then(response => {
          if (response.data.code === 0 && response.data.datas) {
            resolve(response.data.datas);
          }
        });
      });
    },
    // 获取在售商品数（sku)
    getSkuQuantity() {
      let v = this;
      v.axios.get(api.get_ymsCoreCommon_skuQuantity).then((response) => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (Object.keys(data).length > 0) {
            for (let key in v.skuData) {
              data[key] = v.priceTransform(data[key]);
            }
          }
          v.skuData = data;
        }
      });
    }
  },
  computed: {
    rankingColumns() {
      let v = this;
      let basic = [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002874'),
          minWidth: 70,
          align: 'left',
          render(h, params) {
            let backColor = '#AAAAAA';
            if (params.index < 3) {
              backColor = '#1890FF';
            }
            return h('span', {
              style: {
                backgroundColor: backColor,
                width: '22px',
                height: '22px',
                borderRadius: '13px',
                color: '#fff',
                textAlign: 'center',
                lineHeight: '22px',
                display: 'inline-block'
              }
            }, params.index + 1);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002872'),
          align: 'left',
          minWidth: 100,
          key: 'totalOrderQuantity'
        },
        {
          key: 'rate',
          align: 'left',
          minWidth: 90,
          renderHeader(h, params) {
            return v.rankType === 1 ? h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002875')) : h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002876'));
          },
          render(h, params) {
            if (params.row.rate) {
              let rate = params.row.rate * 100;
              rate = rate.toFixed(0);
              if (params.row.rate > 0) {
                return h('div', {
                  class: 'flex align-items-center'
                }, [
                  h('Icon', {
                    props: {
                      type: 'ios-arrow-round-up',
                      size: 22
                    },
                    style: {
                      color: '#E92B42',
                      fontWeight: 'bold'
                    }
                  }),
                  h('span', rate + '%')
                ]);
              } else if (params.row.rate < 0) {
                return h('div', {
                  class: 'flex align-items-center'
                }, [
                  h('Icon', {
                    props: {
                      type: 'ios-arrow-round-down',
                      size: 22
                    },
                    style: {
                      color: '#35C544',
                      fontWeight: 'bold'
                    }
                  }),
                  h('span', Math.abs(rate) + '%')
                ]);
              }
            } else {
              return h('span', 0);
            }
          }
        }
      ];
      if (this.orderTabsValue === '0') {
        basic.splice(1, 0, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098'),
          align: 'left',
          minWidth: 110,
          key: 'supplierMerchantId'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001101'),
          align: 'left',
          minWidth: 140,
          key: 'name',
          render(h, params) {
            let name = v.merchantArr.filter(i => i.ymsMerchantId === params.row.supplierMerchantId)[0].name;
            return h('span', name);
          }
        });
        return basic;
      } else if (this.orderTabsValue === '1') {
        basic.splice(1, 0, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002877'),
          align: 'left',
          minWidth: 110,
          key: 'distributorMerchantId',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002878'),
          key: 'name',
          minWidth: 140,
          align: 'left',
          render(h, params) {
            let name = v.merchantArr.filter(i => i.ymsMerchantId === params.row.distributorMerchantId)[0].name;
            return h('span', name);
          }
        });
        return basic;
      }
    }
  }
};
</script>
<style>
.statistics-box .ivu-tabs-nav .ivu-tabs-tab {
  padding: 16px 16px;
}

.statistics-box .ivu-tabs-nav .ivu-tabs-tab {
  font-size: 16px;
}
</style>
<style lang="less" scoped>
.cursor-pointer {
  cursor: pointer
}

.mt24 {
  margin-top: 24px;
}

.data-content {
  background-color: #ffffff;
  padding: 30px;
  min-height: 240px;
  white-space: nowrap;
  border-radius: 5px;

  .head {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #00000072;
  }

  .account {
    margin-top: 15px;
    color: #000000;

    .currency {
      font-size: 22px;
    }

    .price {
      font-family: 'Arial Normal', 'Arial', sans-serif;
      font-weight: 400;
      font-size: 24px;
    }
  }

  .relevant {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-top: 15px;
    color: #00000072;

    .price {
      margin-left: 5px;
      color: #000000;
      font-size: 16px;
    }
  }
}

.card-box {
  .line-header {
    color: #000000d8;
    font-size: 17px;
    font-weight: bold;
  }

  .sub-title {
    font-family: 'Arial Normal', 'Arial', sans-serif;
    font-weight: 400;
    font-style: normal;
    color: #00000072;
    margin-top: 10px;
  }

  .sub-quantity {
    font-family: 'Arial Normal', 'Arial', sans-serif;
    font-weight: 400;
    font-size: 36px;
    color: #000000;
    margin-top: 10px;
  }
}

.footer-box {
  background-color: #ffffff;
  border-radius: 5px;
}

.activeColor {
  color: #2D8CF0;
}

.f-18 {
  font-size: 18px;
  color: #2D8CF0;
}

.reset_tooltip_style {
  position: relative !important;

  /deep/ .ivu-tooltip-popper {
    position: absolute;
    top: -50px !important;
    left: -441px !important;
  }

  /deep/ .ivu-tooltip-inner {
    width: 470px;
  }
}
</style>
